import { Slider } from "../../components/slider/slider";


export class StructureRelatedCards {
    defaultOptions = {
        wrapperClass: 'card-slider__content',
        slideClass: 'card-news',
        spaceBetween: 1,
        slidesPerView: 4,
        slidesPerColumn: 1,
        slidesPerGroup: 4,
        initialSlide: 0,
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                slidesPerColumn: 1,
                slidesPerGroup: 1
            }
        },
        navigation: {
            prevEl: '.pagination-control__navigation--prev',
            nextEl: '.pagination-control__navigation--next'
        },
        pagination: {
            el: '.swiper-pagination__page',
            dynamicBullets: false,
        }
    };

    // staff
    structuresRelatedCards = $('.structure--related-cards');

    constructor() {
        this.init();
    }

    init() {
        if (!this.structuresRelatedCards.length) {
            return;
        }

        this.structuresRelatedCards.each((key, structuresRelatedCard) => {
            const relatedCard = $(structuresRelatedCard);

            // Necesitamos hacer esto para que no se repita la paginación y muestre los bullets de cada módulo.
            const pagination = relatedCard.parent().find( "div[class^='swiper-pagination__page--']" );
            if (pagination) {
                this.defaultOptions.pagination.el = '.' + pagination.attr('class');
            }

            this.update(relatedCard);
        });
    }

    update(relatedCard) {
        new Slider(relatedCard, this.defaultOptions);
    }
}
